export default __webpack_public_path__ + "static/hsbc-b49c8da7e87d1176813387773c54b8df.png";